import { render } from "./sounds-of-india.vue?vue&type=template&id=86332c2c&scoped=true"
import script from "./sounds-of-india.vue?vue&type=script&lang=js"
export * from "./sounds-of-india.vue?vue&type=script&lang=js"

import "./sounds-of-india.vue?vue&type=style&index=0&id=86332c2c&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86332c2c"]])

export default __exports__